import { createStyles, withStyles } from '@material-ui/styles';
import { validations } from '@topconagriculture/frontend-utils';
import { AutocompleteSelect, SelectItem, TextInput } from '@topconagriculture/react-components';
import { default as cl, default as cn } from 'classnames';
import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import { compose, defaultProps, pure, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { change, Field, formValueSelector } from 'redux-form';
import { getBillableCountryList, getCountryList } from '../../store';
const styles = (theme) => createStyles({
    root: {},
    countryFieldWrapper: {},
    coutriesInputWrapper: {
        marginTop: theme.space.margin.small,
    },
    statesInputWrapper: {
        marginTop: theme.space.margin.default,
    },
    flagIcon: {
        width: 26,
        height: 24,
        marginRight: theme.space.margin.small,
    },
    countryLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
});
const findCountryByCode = (countries, countryCode) => countries.find((co) => co.code === countryCode);
const CountrySelect = (props) => {
    const { classes, countryFieldName, stateFieldName, stateFieldInputName, countryEditable, countryFieldPlaceholder, countryFieldInputPlaceholder, stateFieldPlaceholder, stateFieldInputPlaceholder, stateFieldLabel, countryFieldLabel, countryNotFoundText, stateNotFoundText, countryFieldDisabled, stateFieldDisabled, onlyBillables, className, showImages = true, countryFieldClass, testId = 'CountrySelect', selectedCountry, handleChange, stateFieldRequired, dropdownPosition, countryList, imagesBaseUrl = 'https://tapprodstoragecommon.blob.core.windows.net/graphic-resources/assets/images/common/countries/', } = props;
    const countries = !countryList ? useSelector(onlyBillables ? getBillableCountryList : getCountryList) : countryList;
    if (!countries.length) {
        console.warn('@@TAP/country: No data provided');
        return null;
    }
    const countryListData = countries.map((c) => ({
        value: c.code,
        label: c.name,
    }));
    const foundCountry = findCountryByCode(countries, selectedCountry);
    const stateListData = (foundCountry &&
        foundCountry.states &&
        foundCountry.states.length > 0 &&
        foundCountry.states.map((s) => ({
            value: s.name,
            label: s.name,
        }))) ||
        [];
    const statesComponent = !stateFieldDisabled && stateListData.length > 0 ? (React.createElement("div", { className: classes.statesInputWrapper },
        React.createElement(Field, { testId: `${testId}-${stateFieldName}`, name: stateFieldName, component: AutocompleteSelect, label: `${stateFieldLabel} *`, placeholder: stateFieldPlaceholder, disabled: stateFieldDisabled, props: {
                listData: stateListData,
                notFoundText: stateNotFoundText,
                dropdownPosition: dropdownPosition || 'fixed',
            }, customOption: (option) => {
                return (React.createElement(SelectItem, Object.assign({}, option.innerProps, { testId: `${option.testId || option.value}-item` }),
                    React.createElement("span", { className: classes.countryLabel, title: option.label }, option.label)));
            }, validate: [validations.strings.notEmpty], required: true }))) : (React.createElement("div", { className: classes.statesInputWrapper },
        React.createElement(Field, { testId: `${testId}-${stateFieldInputName || stateFieldName}`, name: stateFieldInputName || stateFieldName, component: TextInput, disabled: stateFieldDisabled, label: `${stateFieldLabel} ${stateFieldRequired ? '*' : ''}`, fullWidth: true, placeholder: stateFieldInputPlaceholder || stateFieldPlaceholder, validate: stateFieldRequired ? [validations.strings.notEmpty] : [] })));
    const countriesComponent = countryEditable ? (React.createElement("div", { className: cl(classes.countryFieldWrapper, countryFieldClass) },
        React.createElement(Field, { testId: `${testId}-${countryFieldName}`, name: countryFieldName, component: AutocompleteSelect, label: `${countryFieldLabel} *`, disabled: countryFieldDisabled, placeholder: countryFieldPlaceholder, customOption: (option) => {
                return (React.createElement(SelectItem, Object.assign({}, option.innerProps, { testId: `${option.testId || option.value}-item` }),
                    showImages && (React.createElement("img", { className: classes.flagIcon, alt: option.value, src: `${imagesBaseUrl}${option.value.toLowerCase()}.svg` })),
                    React.createElement("span", { className: classes.countryLabel, title: option.label }, option.label)));
            }, props: {
                listData: countryListData,
                notFoundText: countryNotFoundText,
                dropdownPosition: dropdownPosition || 'fixed',
            }, onChange: handleChange, required: true, validate: [validations.strings.notEmpty] }))) : (React.createElement("div", { className: cl(classes.countryFieldWrapper, countryFieldClass), "data-testid": `${testId}` },
        React.createElement(Field, { testId: `${testId}-${countryFieldName}`, name: countryFieldName, component: TextInput, label: `${countryFieldLabel}`, props: { disabled: true }, placeholder: countryFieldInputPlaceholder || countryFieldPlaceholder, fullWidth: true, disabled: true, format: ((value) => {
                const matchedCountry = findCountryByCode(countries, value);
                return (matchedCountry && matchedCountry.name) || '';
            }) })));
    return (React.createElement("div", { className: cn(classes.root, className), "data-testid": `${testId}` },
        React.createElement("div", { className: classes.coutriesInputWrapper }, countriesComponent),
        statesComponent));
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
    change,
}, dispatch);
const mapStateToProps = (state, props) => {
    const selector = formValueSelector(props.formId);
    const selectedCountry = selector(state, props.countryFieldName || 'country');
    const selectedState = selector(state, props.stateFieldName || 'state');
    return {
        selectedCountry,
        selectedState,
    };
};
const ComposedCountrySelect = compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles, { withTheme: true }), pure, defaultProps({
    countryFieldName: 'country',
    stateFieldName: 'state',
    countryEditable: true,
    stateFieldInputName: 'state',
    countryNotFoundText: 'Country not found',
    stateNotFoundText: 'State not found',
}), withHandlers({
    handleChange: (props) => (e, countryCode, prevCountryCode) => {
        if (countryCode !== prevCountryCode) {
            props.change(props.formId, props.stateFieldName, '');
        }
    },
}))(CountrySelect);
ComposedCountrySelect.displayName = 'CountrySelect';
export default ComposedCountrySelect;
//# sourceMappingURL=CountrySelect.js.map